.provide-labeled-line-input {
  --label-height: 20px;
  display: flex;
  flex-flow: row nowrap;

  /* reset CSS default in some browsers of 'auto' which limits min width */
  min-width: 0;
  &:not(.no-wrapper-margin) {
    margin-top: 12px;
  }
}

.label-and-input-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;

  flex-grow: 1;
  max-width: 100%;

  &:focus-within > .label:not(.error) {
    color: var(--ds-blue);
    font-weight: 700;
    letter-spacing: 0.8px;
  }
}

.label {
  color: var(--ds-grey);
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  letter-spacing: 0.4px;
  font-weight: 500;
  line-height: var(--label-height);
  margin-bottom: 2px;

  &.error {
    color: var(--ds-red-dark);
  }
}

.input-line {
  display: flex;
  flex-flow: row nowrap;
}

.input-line:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--ds-pearl-grey-dark);
  height: 1px;
  border-radius: 1px;
}

.input-line:focus-within:not(.error):after {
  height: 2px;
  background: var(--ds-blue);
}

.input-line.error:after {
  height: 2px;
  background: var(--ds-red);
}

.input,
.prefix {
  padding: 0 0 3px 0;
  transition: var(--transition);
  border: none;
  font-size: 16px;
  font-weight: 500;
  background-color: transparent;

  box-sizing: content-box;
  /*
   * don't define line-height - it messes with the prefix's alignment.
   * used height above instead
   * it seems that a line height that isn't somewhat bigger than the
   * font size is problematic for alignment of <input>s with non-<input>s.
   * see: https://stackoverflow.com/q/33185205/2544629
   */
  /*line-height: 24px;*/
  letter-spacing: 0.3px;
  color: var(--ds-black);

  &:focus {
    transition: var(--transition);
    outline: none;
  }

  &::placeholder {
    color: #6b747d;
  }

  &:focus::placeholder {
    color: color-mix(in srgb, #6b747d 64%, transparent 36%);
  }

  &.xlarge {
    height: 38px;
  }
}

.check-size {
  font-size: 19px;
}

.large {
  font-size: 24px;
}
.xlarge {
  font-size: 38px;
}

.input {
  order: 2;
  flex-grow: 1;
}

.prefix {
  padding-right: 2px;
  order: 1;
  cursor: default;
  user-select: none;
  display: flex;
  align-items: center;

  & sup {
    font-size: 19px;
    vertical-align: 20%;
    height: unset;
    align-self: flex-start;
    margin-top: 2px;
  }
}

.floating-error {
  display: flex;
  flex-flow: column nowrap;
  background-color: var(--ds-red-light);
  color: var(--ds-red-dark);
  font-size: 13px;
  letter-spacing: 0.4px;
  line-height: 20px;
  padding: 2px 8px;
  border-radius: 4px;

  &.no-label {
    bottom: 100%;
  }
}

/* styles just for the built-in error bubble, these are not used for the exported component */
.floating-error-built-in {
  position: absolute;
  bottom: calc(100% - var(--label-height));
}

/* https://leaverou.github.io/bubbly/ */
.floating-error:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 10%;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-top-color: var(--ds-red-light);
  border-bottom: 0;
  margin-left: -5px;
  margin-bottom: -5px;
}

.hintText {
  position: absolute;
  right: 0;

  text-transform: uppercase;
  color: rgba(26, 39, 53, 0.64);
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.incremental {
  align-self: flex-end;
  margin-bottom: 10px;
  margin-left: 8px;

  width: 22px;
  height: 22px;

  order: 3;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 22px;
    height: 22px;
  }
}

.monospace {
  font-family: var(--monospace);
}

.invisible {
  visibility: hidden;
}

/*
These prevent the up/down arrows from appearing
that normally allow you to change the number by 1
*/
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
